import "@/helpers/turbo"
import { register } from "../helpers/stimulus"

import { setupSearchBar } from "@/components/search_bar"

import CarouselController from "../controllers/carousel_controller"
import DisclosureItemController from "../controllers/disclosure_item_controller"
import LoaderController from "../controllers/loader_controller"
import ModalController from "../controllers/modal_controller"
import ModalTriggerController from "../controllers/modal_trigger_controller"
import SnackBarController from "../controllers/snackbar_controller"
import WishlistController from "../controllers/wishlist_controller"

import FiltersFormController from "../controllers/search/filters_form_controller"
import FiltersModalController from "../controllers/search/filters_modal_controller"
import MapMarkerCarouselController from "../controllers/search/map_marker_carousel_controller"
import PriceFilterController from "../controllers/search/price_filter_controller"
import ProgressBarController from "../controllers/search/progress_bar_controller"
import SearchMapController from "../controllers/search/search_map_controller"
import SearchResultsController from "../controllers/search/search_results_controller"

import { ENTRY, prefetchEntry } from "@/helpers/prefetch"

const NEW_SEARCH_PAGE = document.body.getAttribute("data-new-search-page") === "true"
const WISHLIST = document.body.getAttribute("data-wishlist") === "true"

const prefetchVenues = (): void => {
  document.addEventListener("DOMContentLoaded", () => prefetchEntry(ENTRY.VENUES))
}

const setupStimulus = (): void => {
  register("carousel", CarouselController)
  register("filters-form", FiltersFormController)
  register("filters-modal-trigger", ModalTriggerController)
  register("loader", LoaderController)
  register("map-marker-carousel", MapMarkerCarouselController)
  register("price-filter", PriceFilterController)
  register("progress-bar", ProgressBarController)
  register("search-map", SearchMapController)
  register("search-results", SearchResultsController)

  if (NEW_SEARCH_PAGE) {
    register("disclosure-item", DisclosureItemController)
    register("filters-modal", ModalController)
  } else {
    register("filters-modal", FiltersModalController)
  }

  if (WISHLIST) {
    register("snackbar", SnackBarController)
    register("wishlist", WishlistController)
  }
}

setupSearchBar()
setupStimulus()
prefetchVenues()
